// extracted by mini-css-extract-plugin
module.exports = {"contents":"xe","sectionHeading":"ye"};